import { Meta } from '@/components/common';
import {
  CriticalThisWeek,
  LicencePipeline,
  OverviewRail,
  OverviewStats,
} from '@/components/features/dashboard';

/**
 * The admin console's opening screen, laid out as the design draws it.
 *
 * Two columns: the working column, and a gradient rail that bleeds to the
 * viewport edges. The main column opens on the estate's headline totals, then
 * the licence pipeline, then what is critical this week.
 *
 * No `Container` here, and no page heading. The rail has to reach the edges of
 * the window to look right, so this page owns the flex row itself and the
 * rail negates the shell's padding on three sides. The shell's 80px header
 * already carries "Global Dashboard".
 */
export function AdminDashboardPage() {
  return (
    <>
      <Meta title="Overview" />

      <div className="flex min-w-0 gap-5">
        <div className="flex min-w-0 flex-1 flex-col gap-7">
          <OverviewStats />
          <LicencePipeline />
          <CriticalThisWeek />
        </div>

        <OverviewRail />
      </div>
    </>
  );
}
